"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CxLogo = void 0;
const React = __importStar(require("react"));
const CxLogo = (props) => (
//Use this app to convert inkscape svg to react https://react-svgr.com/
React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: 800, height: 800, viewBox: "0 0 211.667 211.667", ...props },
    React.createElement("defs", null,
        React.createElement("linearGradient", { id: "a" },
            React.createElement("stop", { offset: 0, style: {
                    stopColor: "#b70200",
                    stopOpacity: 1,
                } }),
            React.createElement("stop", { offset: 1, style: {
                    stopColor: "#e05516",
                    stopOpacity: 1,
                } })),
        React.createElement("linearGradient", { xlinkHref: "#a", id: "b", gradientUnits: "userSpaceOnUse", x1: 162.432, y1: 233.213, x2: 162.432, y2: 101.579 })),
    React.createElement("g", { style: {
            display: "inline",
        } },
        React.createElement("path", { style: {
                display: "inline",
                fill: "url(#b)",
                fillOpacity: 1,
                stroke: "none",
                strokeWidth: 0.26458332,
                strokeLinecap: "butt",
                strokeLinejoin: "miter",
                strokeMiterlimit: 4,
                strokeDasharray: "none",
                strokeOpacity: 0.94117647,
            }, d: "M122.357 116.373c-8.907 21.98-1.759 47.92 12.27 56.788 14.03 8.867 45.214-2.838 48.677-8.233-11.982-2.795-15.823-19.512-15.823-19.512 14.67 13.83 25.032 8.728 27.448 11.089 2.416 2.36.53 4.746.53 4.746 10.853 4.552 21.669 13.853 20.588 25.345-7.9-5.74-17.793-8.775-30.603-2.646-21.28 10.182-20.451 37.29-36.698 51.64 8.403-2.75 14.046-18.725 24.018-25.234 9.971-6.51 22.339-7.327 31.609-11.45 11.126-4.947 22.035-10.286 28.026-27.46 5.075 34.326-44.632 47.844-44.632 47.844s22.08 2.44 40.853-18.328c-7.988 33.15-51.157 32.861-51.157 32.861s18.132 6.325 38.9-6.456c-15.177 25.562-54.907 17.021-54.907 17.021s15.969 6.627 35.939 4.63c-10.185 7.988-23.156 9.589-38.038 5.563-9.004-2.436-16.53-2.27-24.348.92-8.386 3.422-12.11 17.175-24.402 17.157-36.256-.466-88.856-41.374-88.911-101.6 0-.35.007-.699.004-1.047-.574-66.304 53.749-105.726 105.224-105.777 37.929-.038 57.177 19.763 60.599 24.39 11.72 15.266-4.913 28.351-18.32 31.756-3.704 0-6.44 1.523-8.08 1.725-8 .983-12.047-2.606-16.303-.69 6.572-5.033 10.654-6.895 14.785-7.075 2.358-.103 5.012 2.08 8.417 1.76 4.947-.463 28.176-10.202 15.283-25.882-16.51-15.68-45.287-22.853-68.023-18.046 19.7-.032 47.503 6.21 64.234 13.891 16.73 7.68 32.074 20.002 44.265 41.736 0 0 2.454 3.922 3.07 8.234.617 4.313-1.186 10.788-1.186 10.788-2.341-7.874-7.877-8.379-8.423-11.983-.545-3.604 2.219-6.876 2.219-6.876-23.759-39.512-61.707-46.274-84.22-48.466 26.776 4.72 63.764 20.515 67.072 40.898.755 4.21 2.706 3.944 3.582 8.13.934 4.458.502 8.235-3.548 14.545-.892-5.611-4.699-7.802-5.41-11.629-.713-3.827 1.54-3.405.71-10.506-.83-16.465-37.075-34.669-61.394-35.128-9.14-.41-12.392 2.076-21.115 1.944-12.824.187-22.98-9.084-38.773-1.608-29.635 14.028-47.097 43.845-47.26 84.916-.21 52.587 46.993 92.103 70.816 88.9 10.677-1.635 17.247-7.44 15.261-19.006-1.986-11.566-44.907-17.673-43.309-57.453 10.22 18.63 21.551 23.723 27.853 24.073-7.352-4.551-30.72-27.004-19.12-55.442 4.523 21.551 14.664 31.984 22.197 38.71-7.53-9.984-22.198-39.768-5.154-59.801-.386 19.345 7.926 41.293 12.65 44.44 0 0-12.65-44.44 11-58.047z", transform: "translate(-18.568 -60.51) scale(.97777)" }),
        React.createElement("path", { d: "M119.602 275.08c13.62-1.064 19.506-5.237 22.503-8.026-2.823-1.685-4.518-2.198-8.032-1.55 11.918-10.003 26.39.85 38.732-.639-13.194 6.81-19.273 2.978-23.731 3.29 1.981.926 4.67.966 5.734 4.371-15.412-.662-7.327 4.895-35.206 2.554z", style: {
                display: "inline",
                fill: "#ae0200",
                fillOpacity: 1,
                stroke: "none",
                strokeWidth: 0.26458332,
                strokeLinecap: "butt",
                strokeLinejoin: "miter",
                strokeMiterlimit: 4,
                strokeDasharray: "none",
                strokeOpacity: 1,
            }, transform: "translate(-18.568 -60.51) scale(.97777)" }),
        React.createElement("path", { d: "M219.986 162.944c1.811-8.303 8.573-6.483 10.503-13.09 6.597 20.217-6.47 21.7-6.47 21.7 2.128-2.766 4.259-8.25 2.231-10.209-2.028-1.958-5.2-.316-6.264 1.6z", style: {
                display: "inline",
                fill: "#cb330d",
                fillOpacity: 1,
                stroke: "none",
                strokeWidth: 0.26458332,
                strokeLinecap: "butt",
                strokeLinejoin: "miter",
                strokeMiterlimit: 4,
                strokeDasharray: "none",
                strokeOpacity: 1,
            }, transform: "translate(-18.568 -60.51) scale(.97777)" }))));
exports.CxLogo = CxLogo;
//# sourceMappingURL=CxLogo.js.map